<div class="consultation-popup-container" [class.appointment-started]="appointmentStarted" [class.disabled]="appointmentStarted && rainbowLoading" (click)="startCall()">
  <app-ed-fit-med-profile-extrasmall [fitMedProfile]="appointment.patientFitMedProfile">
    <div subtitle class="flex items-center">
      <div #ref>
        <ng-content select="[fmpSubtitleNgContent]"></ng-content>
      </div>
      @if (ref.childNodes.length === 0) {
        {{ appointment.appointment.startTime| localizedDate : 'shortTime' }}
      }
    </div>

    <div inline class="pl-6 flex items-center">
      <!-- consultation type -->
      <span [class]="appointmentTypeIconValue" class="rounded p-1 appt-type-icon mdi bg-white dark:bg-gray-800">
        <app-icon [icon]="appointmentTypeIconValue" class="text-white"></app-icon>
      </span>

      <!-- stop consultation button -->
      <app-consult-start-stop-btn [appointmentRecordedStartTime]="appointment.appointment.recordedStartTime"
      [appointment]="appointment"></app-consult-start-stop-btn>
    </div>
  </app-ed-fit-med-profile-extrasmall>
</div>
